import { render, staticRenderFns } from "./CandidateWrapper.vue?vue&type=template&id=6c4c4e6a&scoped=true&"
import script from "./CandidateWrapper.vue?vue&type=script&lang=ts&"
export * from "./CandidateWrapper.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c4c4e6a",
  null
  
)

export default component.exports